// Column keys double as backend sort keys (UserFilters::LIST_SORTABLE) — matches the convention
// established for Members/Listing/columns.js. `select` and `member_number` are not sortable,
// same as the legacy DataTable definition for this page.
export function buildColumns() {
  return [
    { key: 'select', label: '', minWidth: '40px', width: '0.3fr' },
    { key: 'first_name', label: 'First Name', sortable: true, minWidth: '100px', width: '1.4fr' },
    { key: 'last_name', label: 'Last Name', sortable: true, minWidth: '130px', width: '2fr' },
    { key: 'member_number', label: 'Membership No.', minWidth: '110px', width: '1.6fr' },
    { key: 'zone_id', label: 'Zone', sortable: true, minWidth: '60px', width: '0.7fr' }
  ]
}

// Below 700px: checkbox + combined name always visible (legacy's `expandedSelect` +
// `expandedHeader` were never hidden behind the accordion toggle, only Membership No/Zone were).
export function buildBreakpoints() {
  return [
    {
      maxWidth: 700,
      hideHeader: true,
      accordion: {
        summary: [
          { keys: ['select'], hideLabel: true },
          { keys: ['name'], hideLabel: true }
        ]
      },
      rows: [
        ['member_number'],
        ['zone_id']
      ]
    }
  ]
}

// Same 'financial' values the backend already filters on (UserFilters::applyListConditions) —
// just relabelled Active/Inactive to match this page's legacy wording instead of Members.vue's
// Financial/Unfinancial. No 'Volunteer' bucket here — the legacy page never had one.
export const FINANCIAL_TABS = [
  { value: 'all', label: 'All' },
  { value: '1', label: 'Active' },
  { value: '0', label: 'Inactive' }
]



// WEBPACK FOOTER //
// ./src/views/Members/Join/columns.js